import axios from "axios";
import getCookie from "utils/customFunctions";

const ISU_API_URL = "https://backend-isu.gstou.ru/api/";

const isuApi = axios.create({ baseURL: ISU_API_URL });

isuApi.interceptors.request.use((config) => {
    const token = getCookie("token");
    if (token) {
        config.headers = { ...config.headers, Authorization: `Bearer ${token}` };
    }
    return config;
});

export const profEducationApi = {
    getBooks: (params) => isuApi.get("elib/profspo/books/", { params }),
    auth: (params) => isuApi.get("elib/profspo/auth/", { params }),
};

export const iprSmartApi = {
    getBooks: (params) => isuApi.get("elib/smart/books/", { params }),
    auth: (params) => isuApi.get("elib/smart/auth/", { params }),
};

export const favoritesApi = {
    getBooks: () => isuApi.get("elib/favorite/"),
    addBook: (book) => {
        const body = new FormData();
        body.append("book", book);
        return isuApi.post("elib/favorite/", body);
    },
};
